import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { checkLicensePermission } from '../../../../utility/communityLicense'
import { addPackage, deletePackage } from '../../../../reducers/programBuilderReducer'

import './Pricing.scss'
import PackageSelect from './PackageSelect'
import PaymentMethodSelect from './PaymentMethodSelect'
import MaterialSelect from './MaterialSelect'

const Pricing = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const current_user = useSelector(state => state.user.current_user)
  const licenseType = current_user.communities[0].license_type
  const communityPackages = useSelector(state => state.programBuilder.communityPackages)
  const communityMaterials = useSelector(state => state.programBuilder.communityMaterials)
  const packages = useSelector(state => state.programBuilder.packages)
  const errors = useSelector(state => state.programBuilder.errors)

  const handleAddPackage = (pkg) => {
    if (pkg.id > 0) {
      dispatch(addPackage(pkg))
    }
  }

  const handleDeletePackage = (pkg) => {
    dispatch(deletePackage(pkg))
  }

  return (
    <section id='Pricing'>
      <p className='title'>{t('programs.builder.pricing.title')}</p>
      <p>
        {t('programs.builder.pricing.intro')}
      </p>
      <div className='row'>
        <div className='col-12 mb-3'>
          <label htmlFor='package' className='mb-3'>
            {t('programs.builder.pricing.pricingPackagesLabel')} {checkLicensePermission(licenseType, ['revenue_share']) && (
              <span className='required-text'>*</span>
            )}
          </label>

          <PackageSelect
            communityPackages={communityPackages}
            packages={packages}
            errors={errors}
            onAddPackage={handleAddPackage}
            onDeletePackage={handleDeletePackage}
          />
        </div>
        {checkLicensePermission(licenseType, ['standard', 'standard_legacy', 'consumer_plan']) && packages.length > 0 && (
          <div className='col-12'>
            <label htmlFor='paymentMethod' className='mb-3'>
              {t('programs.builder.pricing.paymentMethodLabel')} <span className='required-text'>*</span>
            </label>

            <PaymentMethodSelect />
          </div>
        )}
        {communityMaterials.length > 0 && (
          <div className='col-12 mt-3 mb-3'>
            <p className='title'>{t('programs.builder.pricing.materialsTitle')}</p>
            <p>
              {t('programs.builder.pricing.materialsIntro')}
            </p>
            <MaterialSelect />
          </div>
        )}
      </div>
    </section>
  )
}

export default Pricing
